import React, { useMemo } from 'react'
import StageBox from './StageBox'
import { ViewStageContainer } from './styles'
import { StatusType } from 'components/atoms/Status/constants'
import { Stages } from 'screens/Home/Grains/ActivityGrains'
import { useAppSelector } from 'hooks/redux'
import { SaleOrderStatus } from 'store/contracts/types'

interface Props {
  currentStage: Stages
}

const Stepper: React.FC<Props> = ({ currentStage }) => {
  const { selected } = useAppSelector(state => state.contractsV2)

  const statusStageTwo = useMemo(() => {
    if (
      (selected?.agreement && selected?.status === SaleOrderStatus.MIGRATED) ||
      selected?.status === SaleOrderStatus.REJECTED ||
      selected?.status === SaleOrderStatus.REMOVED
    ) {
      return StatusType.SHE_FINISHED
    }
    return StatusType.IN_PROGRESS
  }, [selected])

  const statusStageThree = useMemo(() => {
    if (
      selected?.agreement &&
      selected?.status === SaleOrderStatus.MIGRATED &&
      !selected?.applications?.length
    ) {
      return StatusType.IN_PROGRESS
    } else if (selected?.applications?.length) {
      return StatusType.SHE_FINISHED
    }
    return StatusType.PENDING
  }, [selected])

  const statusStageFour = useMemo(() => {
    if (selected?.applications?.length && !selected.liquidations?.length) {
      return StatusType.IN_PROGRESS
    } else if (selected?.liquidations?.length) {
      return StatusType.SHE_FINISHED
    }
    return StatusType.PENDING
  }, [selected])

  return (
    <ViewStageContainer>
      <StageBox
        title="Etapa 1"
        text="Inicio de venta"
        statusType={StatusType.SHE_FINISHED}
        isSelected={currentStage === Stages.INIT}
      />
      <StageBox
        title="Etapa 2"
        text="Confirmación de contrato"
        statusType={statusStageTwo}
        isSelected={currentStage === Stages.CONFIRMATION}
      />
      <StageBox
        title="Etapa 3"
        text="Entrega de granos"
        statusType={statusStageThree}
        isSelected={currentStage === Stages.QUOTES}
      />
      <StageBox
        title="Etapa 4"
        text="Aplicaciones de entregas de contratos"
        statusType={statusStageFour}
        isSelected={currentStage === Stages.APPLICATIONS}
      />
      <StageBox
        title="Etapa 5"
        text="Liquidaciones"
        statusType={
          selected?.liquidations?.length
            ? StatusType.SHE_FINISHED
            : StatusType.PENDING
        }
        isSelected={currentStage === Stages.LIQUIDATIONS}
      />
    </ViewStageContainer>
  )
}

export default Stepper
